import {
  ActionButton,
  ButtonColumn,
  DateColumn,
  IconColumn,
  TableConfig,
  TextColumn,
} from 'ngx-eo-web-components';
import { Observable } from 'rxjs';
import { IdikaSurgery } from '../../core/models/idika-surgery.model';
import { TableConfigBuilder } from '../../core/interfaces/ITableConfig';

export class IdikaSurgeriesTableConfigBuilder extends TableConfigBuilder<IdikaSurgery> {
  private assignSurgeryFunc:
    | ((item?: IdikaSurgery, event?: any) => void)
    | undefined;

  private toPrivateClinicFunc:
    | ((item?: IdikaSurgery, event?: any) => void)
    | undefined;


  private returnSurgeryFunc:
    | ((item?: IdikaSurgery, event?: any) => void)
    | undefined;

  private isAssignSurgeryBtnVisibleFunc:
    | ((item?: IdikaSurgery) => boolean)
    | undefined;

  private isReturnSurgeryBtnVisibleFunc:
    | ((item?: IdikaSurgery) => boolean)
    | undefined;

  private isViewSurgeryBtnVisibleFunc:
    | ((item?: IdikaSurgery) => boolean)
    | undefined;

  private viewSurgeryFunc:
    | ((item?: IdikaSurgery, event?: any) => void)
    | undefined;

  private surgeryStatusNameFunc: ((item?: IdikaSurgery) => string) | undefined;

  private getIndicationTooltipFunc:
    | ((item?: IdikaSurgery) => string)
    | undefined;

  getColumns() {
    const columns = [
      new TextColumn({
        name: 'Μον. κωδικός ΕΛΧ',
        propertyName: 'uniqueListPatientCode',
      }),
      new TextColumn({
        name: 'Voucher',
        propertyName: 'surgeryCode',
      }),
      new TextColumn({
        name: 'ΑΜΚΑ',
        propertyName: 'patientAmka',
      }),
      new IconColumn({
        name: '',
        propertyName: 'indicationIcon',
        tooltip: (item?: IdikaSurgery) => {
          if (this.getIndicationTooltipFunc) {
            return this.getIndicationTooltipFunc(item);
          }
          return '';
        },
      }),
      new TextColumn({
        name: 'Νοσοκομείο',
        propertyName: 'hospitalName',
      }),
      new TextColumn({
        name: 'Κλινική',
        propertyName: 'clinicName',
      }),
      new TextColumn({
        name: 'Τύπος',
        propertyName: 'surgeryType',
      }),
      new DateColumn({
        name: 'Ημ. κλινικής εκτίμησης',
        propertyName: 'examinationDate',
      }),
      new DateColumn({
        name: 'Ημ. εισαγωγής στην ΕΛΧ',
        propertyName: 'listEntryDate',
      }),
      new TextColumn({
        name: 'Μήνας ανάθεσης',
        propertyName: 'assignmentMonth',
      }),
      new DateColumn({
        name: 'Ημ. ανάθεσης',
        propertyName: 'assignmentDate',
      }),
      new DateColumn({
        name: 'Ημ. χειρουργείου',
        propertyName: 'surgeryDate',
      }),
      new TextColumn({
        name: 'Κατάσταση',
        propertyName: 'surgeryStatusName',
        tooltip: (item?: IdikaSurgery) => {
          if (this.surgeryStatusNameFunc) {
            return this.surgeryStatusNameFunc(item);
          }
          return '';
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-eye p-info',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Προβολή',
          tooltipPosition: 'left',
        },
        action: (item?: IdikaSurgery, event?: any) => {
          if (this.viewSurgeryFunc) {
            this.viewSurgeryFunc(item, event);
          }
        },
        isVisibleAction: (item?: IdikaSurgery) => {
          if (this.isViewSurgeryBtnVisibleFunc) {
            return this.isViewSurgeryBtnVisibleFunc(item);
          } else {
            return false;
          }
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-pen-to-square p-primary',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Ανάθεση',
          tooltipPosition: 'left',
        },
        action: (item?: IdikaSurgery, event?: any) => {
          if (this.assignSurgeryFunc) {
            this.assignSurgeryFunc(item, event);
          }
        },
        isVisibleAction: (item?: IdikaSurgery) => {
          if (this.isAssignSurgeryBtnVisibleFunc) {
            return this.isAssignSurgeryBtnVisibleFunc(item);
          } else {
            return false;
          }
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-arrow-right-arrow-left p-blue',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Μεταφορά σε Ιδιωτική Δομή',
          tooltipPosition: 'left',
        },
        action: (item?: IdikaSurgery, event?: any) => {
          if (this.toPrivateClinicFunc) {
            this.toPrivateClinicFunc(item, event);
          }
        },
        isVisibleAction: (item?: IdikaSurgery) => {
          if (this.isAssignSurgeryBtnVisibleFunc) {
            return this.isAssignSurgeryBtnVisibleFunc(item);
          } else {
            return false;
          }
        },
      }),
      new ButtonColumn({
        classProperties: {
          icon: 'pi pi-chevron-circle-left p-secondary',
          styleClass: 'p-button-text',
          style: { width: '25px', height: '20px' },
          pTooltip: 'Επιστροφή σε Προγραμματισμένο',
          tooltipPosition: 'left',
        },
        action: (item?: IdikaSurgery, event?: any) => {
          if (this.returnSurgeryFunc) {
            this.returnSurgeryFunc(item, event);
          }
        },
        isVisibleAction: (item?: IdikaSurgery) => {
          if (this.isReturnSurgeryBtnVisibleFunc) {
            return this.isReturnSurgeryBtnVisibleFunc(item);
          } else {
            return false;
          }
        },
      }),
    ];

    return columns;
  }

  addIsAssignSurgeryBtnVisibleFunction(
    isAssignSurgeryBtnVisibleFunc: (item?: IdikaSurgery) => boolean
  ): IdikaSurgeriesTableConfigBuilder {
    this.isAssignSurgeryBtnVisibleFunc = isAssignSurgeryBtnVisibleFunc;
    return this;
  }

  addIsReturnSurgeryBtnVisibleFunction(
    isReturnSurgeryBtnVisibleFunc: (item?: IdikaSurgery) => boolean
  ): IdikaSurgeriesTableConfigBuilder {
    this.isReturnSurgeryBtnVisibleFunc = isReturnSurgeryBtnVisibleFunc;
    return this;
  }

  addIsViewSurgeryBtnVisibleFunction(
    isViewSurgeryBtnVisibleFunc: (item?: IdikaSurgery) => boolean
  ): IdikaSurgeriesTableConfigBuilder {
    this.isViewSurgeryBtnVisibleFunc = isViewSurgeryBtnVisibleFunc;
    return this;
  }

  addAssignSurgeryFunction(
    assignSurgeryFunc: (item?: IdikaSurgery, event?: any) => void
  ): IdikaSurgeriesTableConfigBuilder {
    this.assignSurgeryFunc = assignSurgeryFunc;
    return this;
  }

  addToPrivateClinicFuncion(
    toPrivateClinicFunc: (item?: IdikaSurgery, event?: any) => void
  ): IdikaSurgeriesTableConfigBuilder {
    this.toPrivateClinicFunc = toPrivateClinicFunc;
    return this;
  }

  

  addReturnSurgeryFunction(
    returnSurgeryFunc: (item?: IdikaSurgery, event?: any) => void
  ): IdikaSurgeriesTableConfigBuilder {
    this.returnSurgeryFunc = returnSurgeryFunc;
    return this;
  }

  addViewSurgeryFunction(
    viewSurgeryFunc: (item?: IdikaSurgery, event?: any) => void
  ): IdikaSurgeriesTableConfigBuilder {
    this.viewSurgeryFunc = viewSurgeryFunc;
    return this;
  }

  addSurgeryStatusNameFunction(
    surgeryStatusNameFunc: (item?: IdikaSurgery) => string
  ): IdikaSurgeriesTableConfigBuilder {
    this.surgeryStatusNameFunc = surgeryStatusNameFunc;
    return this;
  }

  addGetIndicationTooltipFunction(
    getIndicationTooltipFunc: (item?: IdikaSurgery) => string
  ): IdikaSurgeriesTableConfigBuilder {
    this.getIndicationTooltipFunc = getIndicationTooltipFunc;
    return this;
  }
  getTable(data: IdikaSurgery[]): TableConfig<IdikaSurgery> {
    this.setTitle('')
      .setColumns(this.getColumns())
      .setTableData(data)
      .setLineNumbers(true);

    return this.getTableConfig();
  }
}
